import type { ReactNode } from "react";

/**
 * The state shown when the BFF refuses a service-admin control with `403 superadmin_required`:
 * the control acts on a service-wide resource shared by every tenant, so only a superadmin (an
 * admin of the root team) may use it. Not a reachability error, so it never says "could not be
 * reached".
 */
export function SuperadminOnly(props: { what: string }): ReactNode {
  return (
    <div className="state-box" data-kind="empty" role="status">
      <strong>Superadmin only</strong>
      <span>{props.what} applies to every tenant on this service, so only a superadmin can use it.</span>
    </div>
  );
}
